import { createFileRoute } from '@tanstack/react-router';
import { CatalogoPageAuthCadastrar } from '@/features/catalogo/page/auth/CatalogoPageAuthCadastrar';

export const Route = createFileRoute('/p/catalogo/$slug/auth/cadastrar')({
    component: CatalogoPageAuthCadastrar,
});
